import { Component, Prop } from 'vue-property-decorator';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { GiftEntity } from '@/entities/gift.entity';
import { PropType } from 'vue';

const joins = [
  'category',
  'reactions.emoticon',
  'staffFrom',
  'staffTo'
];

@Component<ThanksMessageListMixin>({
  watch: {
    /**
     * When change keySearch, reset all variables
     * Required 1st
     */
    keySearch: {
      handler(newKeySearch, oldKeySearch) {
        if(newKeySearch !== oldKeySearch) {
          this.setDefault()
        }
      },
      deep: true
    },
    /**
     * When change route, reset all variables
     * Required 2nd
     */
    '$route.path': {
      handler(newPath, oldPath) {
        if(newPath !== oldPath) {
          this.setDefault();
        }
      },
      deep: true
    },
    tmpFilter: {
      handler(filter: [string, string, any][]) {
        if (filter.length > 0) {
          // Remove reload when change filter and when receive socket
          if (filter.some(item => item[0] === "staffToId" || item[0] === "staffFromId") && this.currentPage >= 2 ) {
            return;
          }
          if (filter[0][0] === 'search') {
            this.rawItems = [];
            this.currentPage = 1;
          }
        }
        this.filter = filter;
        this.limit = 20; // reset to default
       },
      deep: true, immediate: true,
    }
  },
})
export default class ThanksMessageListMixin extends CreateListDataMixin<GiftEntity>(
  'gift/index',
  'gift',
  joins,
) {
  // items: GiftEntity[] = [];
  reverse = false; // a flag of CreateListDataMixin
  nextIdToLoad: number; // The post (message) id in where condition
  currentPage = 1;
  endOfPage = false;
  total = 0;
  @Prop({ type: Array as PropType<[string, string, any][]> })
  tmpFilter: [string, string, any][];
  @Prop({ type: String })
  keySearch: string;

  async created(): Promise<void> {
    this.filter = this.tmpFilter;
  }

  /**
   * Set default value for variables
   * @returns {Promise<void>}
   */
  async setDefault() {
      this.rawItems = [];
      this.currentPage = 1;
      this.endOfPage = false;
      this.scrollToTop();
  }

  /**
   * override
   * Fetch thanks messages first time
   */
  async startFetchItem() {
    if (this.fetchFirstTime) {
      await this.beforeFirstFetch();
    } else {
      await this.beforeFetch();
    }
    this.apiStore.$filters = []; // remove old conditions
    // set search conditions at first
    this.filter.forEach(([field, operator, value]: [string, string, any]) => {
      this.apiStore.filter(field, operator, value);
    });

    // get the oldestMessageId
    this.apiStore.$order = []; // remove old orders
    // is 0 when result is empty
    this.apiStore.$order = []; // to be sure old orders are remove

    this.loading = true;
    this.order.forEach(([field, direction]) => {
      this.apiStore.order(field, direction);
    });
    
    this.currentPage = 1;
    [this.rawItems, this.total, this.endOfPage] = await this.apiStore
      .page(this.currentPage, this.limit) // always get 20 records on first reading
      .getMany();

    this.currentPage += 1;
    if(this.rawItems.length < this.limit) {
      this.endOfPage = true
    }

    // last item of result
    const lastItem = this.rawItems[this.rawItems.length - 1];
    // nextIdToLoad must be first id of after lastItem
    this.nextIdToLoad = lastItem == null ? 0 : lastItem.id;

    this.loading = false;
    await this.$nextTick();
    if (this.fetchFirstTime) {
      await this.afterFirstFetch();
      this.fetchFirstTime = false;
    } else {
      await this.afterFetch();
    }
  }

  /**
   * override
   * scroll load more thanks messages
   */
  async windowsScrollHandle() {
    if (!this.$refs.container || this.loading || this.endOfPage) {
      return;
    }
    let el: Element;
    if (this.$refs.container instanceof Element) {
      el = this.$refs.container;
    } else {
      el = this.$refs.container.$el;
    }

    let scrollBottom = 0;
    if (this.scrollEl instanceof Element) {
      scrollBottom =
        this.scrollEl.scrollTop + this.scrollEl.clientHeight + 30;
    }
    if (
      (this.scrollEl === window && this.scrollEl.innerHeight + 150 >= el.getBoundingClientRect().bottom && !this.reverse) ||
        (this.scrollEl instanceof Element && scrollBottom >= (this.scrollEl.scrollHeight - this.scrollEl.scrollHeight*0.3) && !this.reverse) ||
          (this.scrollEl === window && el.getBoundingClientRect().top <= 30 && this.reverse) ||
            (this.scrollEl instanceof Element && this.scrollEl.scrollTop <= 30 && this.reverse)
    ) {
      this.loading = true;
      const request = this.apiStore;
      // refresh search conditions
      for (let i=0; i<request.$filters.length; i+=1) {
        if (request.$filters[i].field === 'id') { // remove old nextIdToLoad (old condition before scroll)
          delete request.$filters[i];
        }
      }
      // Remove empty items after refresh
      request.$filters = request.$filters.filter(item => 
        item != null
      );
      // Get api data for gift
      const [rows] = await request.filter('id', '$lt', (this.nextIdToLoad).toString())
        .limit(this.limit)
        .getMany();
      // Condition to stop load more
      const currentTotal = this.limit * this.currentPage;
      if(rows.length < this.limit || this.total < currentTotal) {
        this.endOfPage = true;
      }    
      // check the request result
      if (rows.length === 0) {
        this.nextIdToLoad -= this.limit;
        // double limit value when get empty result, quick for search
        this.limit *= 2;
      } else {
        // reset nextIdToLoad
        this.nextIdToLoad = rows[rows.length - 1].id;
      }
      
      this.currentPage += 1;
      this.rawItems = [...this.rawItems, ...rows];
      this.loading = false;
    }
  }

  /**
   * Scroll top when change route
   */
  scrollToTop() {
    let el: Element;
    if (this.$refs.container instanceof Element) {
      el = this.$refs.container;
    } else {
      el = this.$refs.container.$el;
    }
    el.scrollIntoView({ behavior: 'smooth' });
  }
  
}
